module.exports = __webpack_public_path__ + "static/froghemoth-914611082ff6baccc1affc9df5e880cc.jpeg";